import { SvgIcon, SvgIconProps } from '@mui/material';

const CustomerIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || '1em'}
    height={props.height || '1em'}
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_16037_2462"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="32"
      height="32"
    >
      <rect width="32" height="32" fill="currentColor" />
    </mask>
    <g mask="url(#mask0_16037_2462)">
      <mask
        id="mask1_16037_2462"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <rect width="32" height="32" fill="currentColor" />
      </mask>
      <g mask="url(#mask1_16037_2462)">
        <path
          d="M5.74392 27.3333C5.07903 27.3333 4.51103 27.0979 4.03992 26.627C3.56903 26.1559 3.33359 25.5879 3.33359 24.923V11.077C3.33359 10.4121 3.56903 9.84411 4.03992 9.373C4.51103 8.90211 5.07903 8.66667 5.74392 8.66667H11.3336V6.41033C11.3336 5.74544 11.569 5.17756 12.0399 4.70667C12.511 4.23556 13.079 4 13.7439 4H18.2566C18.9215 4 19.4895 4.23556 19.9606 4.70667C20.4315 5.17756 20.6669 5.74544 20.6669 6.41033V8.66667H26.2566C26.9215 8.66667 27.4895 8.90211 27.9606 9.373C28.4315 9.84411 28.6669 10.4121 28.6669 11.077V24.923C28.6669 25.5879 28.4315 26.1559 27.9606 26.627C27.4895 27.0979 26.9215 27.3333 26.2566 27.3333H5.74392ZM13.3336 8.66667H18.6669V6.41033C18.6669 6.30767 18.6241 6.21367 18.5386 6.12833C18.4533 6.04278 18.3593 6 18.2566 6H13.7439C13.6413 6 13.5473 6.04278 13.4619 6.12833C13.3764 6.21367 13.3336 6.30767 13.3336 6.41033V8.66667ZM8.66692 10.6667H5.74392C5.64125 10.6667 5.54725 10.7094 5.46192 10.795C5.37637 10.8803 5.33359 10.9743 5.33359 11.077V24.923C5.33359 25.0257 5.37637 25.1197 5.46192 25.205C5.54725 25.2906 5.64125 25.3333 5.74392 25.3333H8.66692V10.6667ZM21.3336 25.3333V10.6667H10.6669V25.3333H21.3336ZM23.3336 10.6667V25.3333H26.2566C26.3593 25.3333 26.4533 25.2906 26.5386 25.205C26.6241 25.1197 26.6669 25.0257 26.6669 24.923V11.077C26.6669 10.9743 26.6241 10.8803 26.5386 10.795C26.4533 10.7094 26.3593 10.6667 26.2566 10.6667H23.3336Z"
          fill="currentColor"
        />
      </g>
    </g>
  </SvgIcon>
);

export default CustomerIcon;
